import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"

export default class SignOutRoute extends Route {
  @service("ember-store")
  store

  @service
  session

  @service
  ajax

  afterModel(transition) {
    super.afterModel(...arguments)
    scheduleOnce("afterRender", async () => {
      if (get(this, "session.isAuthenticated") === true) {
        await get(this, "session").signOut()
      }

      if (window && window.location) {
        window.location.replace("/")
      }
    })
  }
}
